const fusoBrasil = "America/Sao_Paulo";

export function formatarDataHoraBrasil(
  valor?: Date | string | null
): string {
  if (valor == null || valor === "") return "";

  const data = valor instanceof Date ? valor : new Date(valor);
  if (Number.isNaN(data.getTime())) return "";

  const partes = new Intl.DateTimeFormat("pt-BR", {
    timeZone: fusoBrasil,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  }).formatToParts(data);

  const ler = (tipo: Intl.DateTimeFormatPartTypes) =>
    partes.find((parte) => parte.type === tipo)?.value ?? "";

  return `${ler("day")}/${ler("month")}/${ler("year")} ${ler("hour")}:${ler(
    "minute"
  )}:${ler("second")}`;
}
